module.exports = __webpack_public_path__ + "static/media/impuestorosa.5046159c.jpg";